import cx from 'classnames';
import PropTypes from 'prop-types';

import LoadingSpinner from '@app/components/LoadingSpinner';

const propTypes = {
  children: PropTypes.node,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  overLayClassName: PropTypes.string,
  spinnerClassName: PropTypes.string,
};

const defaultProps = {
  children: null,
  message: null,
  overLayClassName: '',
  spinnerClassName: '',
};

/**
 * GlobalLoadingSpinner은 로딩이 뜰 때, overLay가 페이지 전역을 덮는 것을 의미합니다.
 */

function GlobalLoadingSpinner(props) {
  const { children, message, overLayClassName, spinnerClassName } = props;
  return (
    <div data-testid="global-spinner">
      {children}
      <div className={cx('Overlay', 'Overlay--high-z-index', overLayClassName)}>
        <div className={cx('LoadingSpinner__spinner', spinnerClassName)}>
          <LoadingSpinner color="white" />
          {message && <p className="LoadingSpinner__spinner-text">{message}</p>}
        </div>
      </div>
    </div>
  );
}

GlobalLoadingSpinner.propTypes = propTypes;
GlobalLoadingSpinner.defaultProps = defaultProps;

export default GlobalLoadingSpinner;
